import React, { useState } from 'react'
import Pagination from '@mui/material/Pagination'
import moment from 'moment'
import { EntryGroup } from 'Generated/graphql-types'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Grid,
} from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import { colors } from '@resiliatech/birdsong'
import {
  EditChartDataContainer,
  PaginationContainer,
} from './EditChartData.styled'
import { EditChartDataRow } from './EditChartDataRow'

type EditChartDataProps = {
  entryGroups: EntryGroup[]
  goalId: string
  isDataFilterOpen: boolean
  setIsChartDataEdited: (value: boolean) => void
  setIsDataFilterOpen: (value: boolean) => void
}

const MAX_ROWS_PER_PAGE = 10

export const EditChartData = ({
  entryGroups,
  goalId,
  isDataFilterOpen,
  setIsChartDataEdited,
  setIsDataFilterOpen,
}: EditChartDataProps) => {
  const [page, setPage] = useState(1)

  const categories: Set<string> = new Set()
  entryGroups.forEach((entryGroup) => {
    entryGroup.Entry.forEach((entry) => {
      categories.add(entry.goalToDimension.dimension.title)
    })
  })

  const filteredGroups = entryGroups.filter((e) => !e.archivedAt)
  const pageCount = Math.ceil(filteredGroups.length / MAX_ROWS_PER_PAGE)
  const paginatedChartData = filteredGroups.slice(
    (page - 1) * MAX_ROWS_PER_PAGE,
    page * MAX_ROWS_PER_PAGE
  )

  const handleFilterIconClick = () => {
    setIsDataFilterOpen(!isDataFilterOpen)
  }

  const editableChartData = paginatedChartData
    .sort((a, b) => moment.utc(b.reportedAt).diff(moment.utc(a.reportedAt)))
    .map((group, i) => (
      <EditChartDataRow
        group={group}
        goalId={goalId}
        key={group.id}
        setIsChartDataEdited={setIsChartDataEdited}
        showBorderBottom={paginatedChartData.length - 1 !== i}
      />
    ))

  const categoryHeaders = Array.from(categories).map((category) => (
    <TableCell key={category}>{category}</TableCell>
  ))

  if (!editableChartData.length) return null

  return (
    <EditChartDataContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container alignItems='center' spacing={1}>
                <Grid item>Date</Grid>
                <Grid item>
                  <Grid item paddingTop='5px'>
                    <FilterListIcon
                      onClick={handleFilterIconClick}
                      cursor='pointer'
                      sx={{
                        color: colors.copy.paragraphDark,
                        height: '20px',
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </TableCell>
            {categoryHeaders}
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{editableChartData}</TableBody>
      </Table>
      {pageCount > 1 && (
        <PaginationContainer>
          <Pagination
            count={pageCount}
            onChange={(_, value) => setPage(value)}
            page={page}
          />
        </PaginationContainer>
      )}
    </EditChartDataContainer>
  )
}
